
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quimico-farmaceutico",
      function () {
        return require("private-next-pages/quimico-farmaceutico/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quimico-farmaceutico"])
      });
    }
  